// import 'slick-carousel'

(function( $ ) {

	"use strict";
	
    //  $(document).ready(function(){
          //    custom slider animation 
          var currentSlideT,
              lastSlideT,
              nextQuoteT,
              slides,
              qoutes,
              prevQuoteT;
              
          //   add class to quotes
          qoutes = $('.quote-wrapper').children('.quote-wrapper-item');
          qoutes.first().addClass('quote--is-active');
          
          //add class to slides
          slides = $('.slider').children('.slider-image');
          
           if (slides.length <= 3){
               slides.clone().insertAfter("div.slider-image:last").addClass("cloned");
           }
          slides.first().addClass('is-active');
          slides.first().next().addClass('next');
          $('.slider-image.next').next().addClass('next-2');
          $('.next-2').nextAll().not(':last').addClass('in-active');
          slides.last().addClass('last');
          
         
          //  add css click
            $('.is-active').css({
               "left":"0",
               "opacity": "1",
               "visibility": "visible",
               "z-index": "2",
          })
          if($(window).innerWidth() <= 1200) {
               $('.is-active').css({
                    "left":"0",
                    "opacity": "1",
                    "visibility": "visible",
                    "z-index": "2",
                    "transform": "scale(0.9)",

               })
          }
          if($(window).innerWidth() <= 767) {
               $('.is-active').css({
                    "left":"0",
                    "opacity": "1",
                    "visibility": "visible",
                    "z-index": "2",
                    "transform": "scale(1)",

               })
          }
          // $('.next').css({
          //      "left":"calc(100% + 40px)",
          //      "opacity": "0.5",
          //      "visibility": "inherit",
          //      "transform": "scale(0.75)",
          // })
          if($(window).innerWidth() >= 1200) {
               $('.slider-image.next').css({
                    "left":"calc(100% + 36px)",
                    "opacity": "0.5",
                    "visibility": "inherit",
                    "transform": "scale(0.75)",
               })  
          }else{
               $('.slider-image.next').css({
                    "left":"calc(100% + 16px)",
                    "opacity": "0.5",
                    "visibility": "inherit",
                    "transform": "scale(0.75)",
               })
          }
          $('.next-2').css({
               "left":"calc(200% + -22px)",
               "opacity": "0.5",
               "visibility": "inherit",
               "transform": "scale(0.50)",
          })
          $('.in-active').css({
               "left":"calc(300% + -22px)",
               "opacity": "0.5",
               "visibility": "inherit",
               "transform": "scale(0.50)",
          })
          $('.last').css({
               "left":"0",
               "opacity": "0",
               "visibility": "inherit",
               "transform": "scale(0.50)",
          })
          if (slides.length==3){
               $('.slider-image.next').css({
                    "left":"calc(100% + 160px)",
                    "opacity": "0.5",
                    "visibility": "inherit",
                    "transform": "scale(0.75)",
               })  
                 $('.next-2').css({
                    "left":"calc(200% + 40px)",
                    "opacity": "0.5",
                    "visibility": "inherit",
                    "transform": "scale(0.50)",
               })
               $('.cloned').css({
                    "left":"0",
                    "opacity": "0",
                    "visibility": "inherit",
                    "transform": "scale(0.50)",
               })
           }else if(slides.length==2){
                  $('.cloned').css({
                    "left":"0",
                    "opacity": "0",
                    "visibility": "inherit",
                    "transform": "scale(0.50)",
               })
                $('.slider-image.next').css({
                    "left":"calc(100% + 36px)",
                    "opacity": "0.5",
                    "visibility": "inherit",
                    "transform": "scale(0.75)",
               }) 
                $('.next-2').css({
                    "left":"calc(200% + -22px)",
                    "opacity": "0.5",
                    "visibility": "inherit",
                    "transform": "scale(0.50)",
               })
           }
              
              
          
          // Next Button
          $(".control.next").on("click", (e) => {
               var  nextSlide,
                    currentSlide,
                    nextSlide2,
                    lastSlide,
                    prevSlide,
                    nextQuote,
                    currentQuote;
                 
               //   disbale controls
               $(".control.next").css({"pointer-events":"none"});
               $(".control.prev").css({"pointer-events":"none"});
          
               //   Clearing timeouts
               clearTimeout(currentSlideT);
               clearTimeout(lastSlideT);
               clearTimeout(nextQuoteT);
                 
               //   Quote
               if($('.quote--is-active').is(':last-child')) {
                    nextQuote = $('.quote--is-active').parent().children().first();
               } else {
                    nextQuote = $('.quote--is-active').next();
               }
               if( nextQuote.is( ':first-child' ) ) {
                    currentQuote = nextQuote.parent().children().last();
               } else {
                    currentQuote = nextQuote.prev();
               }
               currentQuote.removeClass('quote--is-active').css({
                    "transform":"translateY(-5%)", 
                    "opacity": 0, 
                    "transition-duration":"0.75s"
               });
               
               nextQuote.addClass('quote--is-active').css({
                    "transform":"translateY(5%)", 
                    "opacity": 0, 
                    "transition-duration":"0s"
               });
               
               var nextQuoteT = setTimeout(()=> {
                    nextQuote.css({
                         "transform":"translateY(0)", 
                         "opacity":1, 
                         "transition-duration":"0.75s"
                    });
               }, 700);
                 
               //   Images
               if($('.is-active').is( ':last-child' )) {
                    nextSlide = $('.is-active').parent().children().first();
               } else {
                    nextSlide = $('.is-active').next();
               }
               if( nextSlide.is( ':first-child' ) ) {
                    currentSlide = nextSlide.parent().children().last();
               } else {
                    currentSlide = nextSlide.prev();
               }
               if( nextSlide.is( ':last-child' ) ) {
                    nextSlide2 = nextSlide.parent().children().first();
               } else {
                    nextSlide2 = nextSlide.next(); 
               }
               if( nextSlide2.is(':last-child') ) {
                    lastSlide = nextSlide.parent().children().first();
               } else {
                    lastSlide = nextSlide2.next();
               }
               if( currentSlide.is(':first-child') ) {
                    prevSlide = currentSlide.parent().children().last();
               } else {
                    prevSlide = currentSlide.prev();
               }
                 
               //   css transition  on next btn click
               currentSlide.removeClass('is-active').css({
                    "transform":"scale(0.5)", 
                    "opacity":0, 
                    "transition-duration":"1s"
                    
               });
               
               nextSlide.addClass("is-active").css( { 
                    "left": "0", 
                    "transform": "scale(1)", 
                    "transition-duration":"1.5s", 
                    "opacity": 1 
                    
               });
               // nextSlide2.css({
               //      "transform":"scale(0.76)", 
               //      "left": "calc(100% + 40px)", 
               //      "opacity":0.5, 
               //      "transition-duration":"1.5s"
                    
               // });
                if($(window).innerWidth() >= 1200) {
                      nextSlide2.css({
                         "transform":"scale(0.76)", 
                         "left": "calc(100% + 34px)", 
                         "opacity":0.5, 
                         "transition-duration":"1.5s"
                         
                    });
                }else{
                     nextSlide2.css({
                         "transform":"scale(0.76)", 
                         "left": "calc(100% + 34px)", 
                         "opacity":0.5, 
                         "transition-duration":"1.5s"
                         
                    }); 
                }
               lastSlide.css({
                    "transform":"scale(0.5)",
                    "left": "calc(270%)",
                    "opacity":0.5,
                    "transition-duration":"0s"
                    
               });
               var lastSlideT = setTimeout(()=> {
               lastSlide.css({
                    "transform":"scale(0.5)", 
                    "left": "calc(200% + -22px)", 
                    "opacity":0.5, 
                    "transition-duration":"1.5s"
                    
               });
               }, 0.1);
               var currentSlideT = setTimeout(()=> {
                    currentSlide.css({
                         "transform":"scale(0.5)", 
                         "left": "270%", 
                         "opacity": 0, 
                         "transition-duration":"0s"
                         
                    });
               }, 1001);
               
               var enableButton = setTimeout(()=> {
                    $(".control.next").css({"pointer-events":"auto"});
                    $(".control.prev").css({"pointer-events":"auto"});
               }, 1501);
          });
          
          // PREV Button
          $(".control.prev").on("click", () => {
               var  nextSlide,
                    prevSlide,
                    currentSlide,
                    nextSlide2,
                    lastSlide,
                    prevQuote,
                    currentQuote;
            
               //   disable controls
               $(".control.prev").css({"pointer-events":"none"});
               $(".control.next").css({"pointer-events":"none"});
               
               //   Clear Timeouts
               clearTimeout(currentSlideT);
               clearTimeout(lastSlideT);
               clearTimeout(prevQuoteT);
     
               //   Quote
               if($('.quote--is-active').is(':first-child')) {
                    prevQuote = $('.quote--is-active').parent().children().last();
               } else {
                    prevQuote = $('.quote--is-active').prev();
               }
               if( prevQuote.is( ':last-child' ) ) {
                    currentQuote = prevQuote.parent().children().first();
               } else {
                    currentQuote = prevQuote.next();
               }
               currentQuote.removeClass('quote--is-active').css({
                    "transform":"translateY(-5%)", 
                    "opacity": 0, 
                    "transition-duration":"0.75s"
                    
               });
               prevQuote.addClass('quote--is-active').css({
                    "transform":"translateY(5%)",
                    "opacity": 0, 
                    "transition-duration":"0s"
                    
               });
               var prevQuoteT = setTimeout(()=> {
                    prevQuote.css({
                         "transform":"translateY(0)", 
                         "opacity":1, 
                         "transition-duration":"0.75s"
                         
                    });
               }, 750);
     
               //   Images
               if($('.is-active').is( ':last-child' )) {
                    nextSlide = $('.is-active').parent().children().first();
               } else {
                    nextSlide = $('.is-active').next();
               }
               if( nextSlide.is( ':first-child' ) ) {
                    currentSlide = nextSlide.parent().children().last();
               } else {
                    currentSlide = nextSlide.prev();
               }
               if( nextSlide.is( ':last-child' ) ) {
                    nextSlide2 = nextSlide.parent().children().first();
               } else {
                    nextSlide2 = nextSlide.next(); 
               }
               if( nextSlide2.is(':last-child') ) {
                    lastSlide = nextSlide.parent().children().first().next();
               } else {
                    lastSlide = nextSlide2.next();
               }
               if( currentSlide.is(':first-child') ) {
                    prevSlide = currentSlide.parent().children().last();
               } else {
                    prevSlide = currentSlide.prev();
               }
              
             
               //   css transition  on prev btn click
              
               if($(window).innerWidth() >= 1100) {
                    currentSlide.removeClass('is-active').css({
                         "transform":"scale(0.76)", 
                         "left": "calc(100% + 36px)", 
                         "opacity":0.5, 
                         "transition-duration":"1.5s"
                         
                    });
               } else {
                    currentSlide.removeClass('is-active').css({
                         "transform":"scale(0.75)", 
                         "left": "calc(100% + 40px)", 
                         "opacity":0.5, 
                         "transition-duration":"1.5s"
                         
                    });
               }
               nextSlide.css({
                    "transform":"scale(0.5)", 
                    "left": "calc(200% + -22px)", 
                    "opacity":0.5, 
                    "transition-duration":"1.5s"
                    
               });
               nextSlide2.css({
                    "transform":"scale(0.5)", 
                    "left": "calc(270%)", 
                    "opacity":0, 
                    "transition-duration":"1.5s"
                    
               });
               lastSlide.css({
                    "transform":"scale(0.5)", 
                    "left": "270%", 
                    "opacity":0, 
                    "transition-duration":"0s"
                    
               });
               
               prevSlide.addClass("is-active").css({
                    "transform":"scale(0.5)", 
                    "left": "0", 
                    "opacity":0, 
                    "transition-duration":"0s"
                    
               });
               var currentSlideT = setTimeout(()=> {
                    prevSlide.addClass("is-active").css({
                         "transform":"scale(1)", 
                         "left": "0", 
                         "opacity":1, 
                         "transition-duration":"1s"
                         
                    });
                   
                   
               }, 0.1);
                
                $('.is-active').next().css({
                    "transform":"scale(0.76)", 
                    "left": "calc(100% + 36px)", 
                    "opacity":0.5, 
                    "transition-duration":"1.5s"
               });
               if($(window).innerWidth() <= 1100) {
                     $('.is-active').next().css({
                         "transform":"scale(0.76)", 
                         "left": "calc(100% + 40px)", 
                         "opacity":0.5, 
                         "transition-duration":"1.5s"
                    });
               }
               var enableButton = setTimeout(()=> {
                    $(".control.prev").css({"pointer-events":"auto"});
                    $(".control.next").css({"pointer-events":"auto"});
               }, 1501);
               
          });
        
    //  });
})(jQuery);
